import { forwardRef, useImperativeHandle, useState, useMemo, useEffect } from 'react';
import { Form, message, Modal, Select } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon } from "../../../locales";
import { CardServer, CommonServer } from "../../../server";
// import { generateTypeFormConfig } from './config'

const server = CardServer.Card;
const commonServer = CommonServer.Level

const DEFAULT_OPERATION_DATA = {
    CheckResult: null,
    RechargeId: null,
    Remark: null,
}

type OperateModeType = 'modifyType'


export const ModifyType = forwardRef((props: any, ref: any) => {
    const { onSuccess, options } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('modifyType');
    const [cardTypes, setCardTypes] = useState<any[]>([]);
    const [selectedCardType, setSelectedCardType] = useState('');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))
    
    // 获取卡片列表
    const fetchCardLevel = async () => {
      const data = await commonServer.list({});
      setCardTypes(data);
    };
    // 初始化加载数据
    useEffect(() => {
      fetchCardLevel()
    }, []);
    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...(mode === 'modifyType' ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(server.modifyCardType, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(langCommon?.operateSuccess);
            changeVisible(false);
            setSelectedCardType("")
            onSuccess?.();
        }
    });
    const closeModel = ()=> {
        changeVisible(false)
        setSelectedCardType("")
    }
    // const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
    //     return generateTypeFormConfig({ formData, mode, options });
    // }, [formData, mode, options]);

    return (
        <div>
            <Modal
                title={'更改卡片等级'}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={closeModel}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    const { Id } = formData
                    const params = {
                        CardId: Id,
                        CategoryId: selectedCardType,
                    }
                    run(params)
                }}
            >
                <Form
                    form={form}
                  layout="vertical"
                  autoComplete="off"
                >
                  <Form.Item
                    label="卡片等级"
                    name="cardType"
                  >
                    
                    <Select placeholder="请选择卡片等级"
                      onChange={id => setSelectedCardType(id)}
                    >
                      {cardTypes.map(type => (
                        <Select.Option key={type.Id} value={type.Id}>
                      {type.Name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form>
            </Modal>
        </div>
    );
})
